import { render, staticRenderFns } from "./RecommendScore.vue?vue&type=template&id=10ede170&scoped=true"
import script from "./RecommendScore.vue?vue&type=script&lang=js"
export * from "./RecommendScore.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10ede170",
  null
  
)

export default component.exports